module.exports = __webpack_public_path__ + "img/right1.669212e9.png";